import {
  uploadStatement,
  getStatementFiles,
  getStatementRecords,
  reprocessStatements,
  reprocessAllStatements,
  getReprocessLogs,
} from '../../services/ProcessStatementService';
import { formatSuccess, formatError } from '../../services/commonServices';

export const PROCESS_STATEMENT_UPLOAD_INITIATED = 'PROCESS_STATEMENT_UPLOAD_INITIATED';
export const PROCESS_STATEMENT_UPLOAD_SUCCESS = 'PROCESS_STATEMENT_UPLOAD_SUCCESS';
export const PROCESS_STATEMENT_UPLOAD_FAILED = 'PROCESS_STATEMENT_UPLOAD_FAILED';

export const PROCESS_STATEMENT_FILES_INITIATED = 'PROCESS_STATEMENT_FILES_INITIATED';
export const PROCESS_STATEMENT_FILES_LOADED = 'PROCESS_STATEMENT_FILES_LOADED';
export const PROCESS_STATEMENT_FILES_FAILED = 'PROCESS_STATEMENT_FILES_FAILED';

export const PROCESS_STATEMENT_RECORDS_INITIATED = 'PROCESS_STATEMENT_RECORDS_INITIATED';
export const PROCESS_STATEMENT_RECORDS_LOADED = 'PROCESS_STATEMENT_RECORDS_LOADED';
export const PROCESS_STATEMENT_RECORDS_FAILED = 'PROCESS_STATEMENT_RECORDS_FAILED';

export const PROCESS_STATEMENT_REPROCESS_INITIATED = 'PROCESS_STATEMENT_REPROCESS_INITIATED';
export const PROCESS_STATEMENT_REPROCESS_SUCCESS = 'PROCESS_STATEMENT_REPROCESS_SUCCESS';
export const PROCESS_STATEMENT_REPROCESS_FAILED = 'PROCESS_STATEMENT_REPROCESS_FAILED';

export const PROCESS_STATEMENT_REPROCESS_ALL_INITIATED = 'PROCESS_STATEMENT_REPROCESS_ALL_INITIATED';
export const PROCESS_STATEMENT_REPROCESS_ALL_SUCCESS = 'PROCESS_STATEMENT_REPROCESS_ALL_SUCCESS';
export const PROCESS_STATEMENT_REPROCESS_ALL_FAILED = 'PROCESS_STATEMENT_REPROCESS_ALL_FAILED';

export const PROCESS_STATEMENT_LOGS_INITIATED = 'PROCESS_STATEMENT_LOGS_INITIATED';
export const PROCESS_STATEMENT_LOGS_LOADED = 'PROCESS_STATEMENT_LOGS_LOADED';
export const PROCESS_STATEMENT_LOGS_FAILED = 'PROCESS_STATEMENT_LOGS_FAILED';

export const uploadStatementAction = (formData) => {
  return (dispatch) => {
    dispatch({ type: PROCESS_STATEMENT_UPLOAD_INITIATED });
    return uploadStatement(formData)
      .then((response) => {
        formatSuccess('Upload Statement', response.data);
        dispatch({ type: PROCESS_STATEMENT_UPLOAD_SUCCESS, payload: response.data.data });
      })
      .catch((error) => {
        const errData = error?.response?.data || error;
        dispatch({ type: PROCESS_STATEMENT_UPLOAD_FAILED, payload: formatError(errData) });
      });
  };
};

export const loadStatementFiles = () => {
  return (dispatch) => {
    dispatch({ type: PROCESS_STATEMENT_FILES_INITIATED });
    return getStatementFiles()
      .then((response) => {
        dispatch({ type: PROCESS_STATEMENT_FILES_LOADED, payload: response.data.data });
      })
      .catch((error) => {
        dispatch({ type: PROCESS_STATEMENT_FILES_FAILED, payload: error.message });
      });
  };
};

export const loadStatementRecords = (params) => {
  return (dispatch) => {
    dispatch({ type: PROCESS_STATEMENT_RECORDS_INITIATED });
    return getStatementRecords(params)
      .then((response) => {
        dispatch({ type: PROCESS_STATEMENT_RECORDS_LOADED, payload: response.data.data });
      })
      .catch((error) => {
        dispatch({ type: PROCESS_STATEMENT_RECORDS_FAILED, payload: error.message });
      });
  };
};

export const reprocessStatementsAction = (data) => {
  return (dispatch) => {
    dispatch({ type: PROCESS_STATEMENT_REPROCESS_INITIATED });
    return reprocessStatements(data)
      .then((response) => {
        dispatch({ type: PROCESS_STATEMENT_REPROCESS_SUCCESS, payload: response.data.data });
        return response.data;
      })
      .catch((error) => {
        const errData = error?.response?.data || error;
        dispatch({ type: PROCESS_STATEMENT_REPROCESS_FAILED, payload: formatError(errData) });
        return null;
      });
  };
};

export const reprocessAllStatementsAction = (data) => {
  return (dispatch) => {
    dispatch({ type: PROCESS_STATEMENT_REPROCESS_ALL_INITIATED });
    return reprocessAllStatements(data)
      .then((response) => {
        dispatch({ type: PROCESS_STATEMENT_REPROCESS_ALL_SUCCESS, payload: response.data.data });
        return response.data;
      })
      .catch((error) => {
        const errData = error?.response?.data || error;
        dispatch({ type: PROCESS_STATEMENT_REPROCESS_ALL_FAILED, payload: formatError(errData) });
        return null;
      });
  };
};

export const loadReprocessLogs = (params) => {
  return (dispatch) => {
    dispatch({ type: PROCESS_STATEMENT_LOGS_INITIATED });
    return getReprocessLogs(params)
      .then((response) => {
        dispatch({ type: PROCESS_STATEMENT_LOGS_LOADED, payload: response.data.data });
      })
      .catch((error) => {
        dispatch({ type: PROCESS_STATEMENT_LOGS_FAILED, payload: error.message });
      });
  };
};
